import React from "react";
import {Scrollbars} from "react-custom-scrollbars-2";
import {createBrowserRouter, RouterProvider, Navigate} from "react-router";
import {Provider} from "react-redux";
import {PersistGate} from "redux-persist/integration/react";

import Loader from "./components/Loader";
import Toaster from "./components/Toaster/Toaster";
import AppLayout from "./layouts/AppLayout.jsx";
import AuthLayout from "./layouts/Auth";
import configureStore from "./redux/Store";

import "react-phone-number-input/style.css";
import "react-toastify/dist/ReactToastify.css";
import "react-toggle/style.css";
import "./assets/plugins/nucleo/scss/nucleo.scss";
import "./assets/scss/argon-dashboard-react.scss";
import "./default.scss";
import "./themes/test.theme.scss";

function App() {
  const storeObject = configureStore();
  const {store, persistor} = storeObject;
  const router = createBrowserRouter([
    {
      path: "/app/*",
      element: <AppLayout />,
    },
    {
      path: "/auth/*",
      element: <AuthLayout />,
    },
    {
      path: "/",
      element: <Navigate to="/auth/login" replace />,
    },
    {
      path: "*",
      element: <Navigate to="/auth/login" replace />,
    },
  ]);

  return (
    <Scrollbars
      style={{width: "100%", height: "100%"}}
      autoHide
      autoHideTimeout={5000}
      autoHideDuration={200}
    >
      <Provider store={store}>
        <Toaster />
        <Loader />
        <PersistGate loading={null} persistor={persistor}>
          <RouterProvider router={router} />
        </PersistGate>
      </Provider>
    </Scrollbars>
  );
}

export default App;
